import {connect} from "react-redux";
import {AppState} from "../../RootReducer";
import {Dispatch} from "redux";
import {AccountBalance, CurrencyDefinition, PaymentMethod, TransferLimit, WithdrawContext} from "../../http/protocol";
import React from "react";
import {
    confirmWithdraw,
    initWithdraw,
    showPossibleWithdrawErrors,
    updateWithdrawAmount
} from "../../payments/WithdrawActions";

import Title from "../../layout/Title";
import TextField from "../../layout/TextField";
import {t} from "../../i18n";
import {BrandA} from "../buttons/buttons";
import {SelectInput} from "../../user/ui/form";
import {Big} from "big.js";
import {PriorityType} from "../../http/Types";
import {getWithdrawableBalance} from "../../selectors/payments-selectors";
import {hasFiatExchangeAmount, toFiatAmount} from "../../currency/currency-utils";
import {getCurrencyDefinitions, getPreferredFiatExchange} from "../../selectors/settings-selectors";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import { AmountInput } from "../../core/ui/molecules/AmountInput";
import { AppSelect, AppSelectOption } from "../../core/ui/atoms/AppSelect";

interface Props  {
    update? : (amount : string, limit?:TransferLimit) => void,
    confirmWithdraw? : (priority?: string)=>void;
    initWithdraw? : typeof initWithdraw;
    method? : PaymentMethod,
    currency? : string
    amount? : string;
    amountValid? : boolean;
    balance?: AccountBalance;
    currencies?: Array<CurrencyDefinition>;
    showPossibleErrors? : () => void;
    showErrors?: boolean;
    context? : WithdrawContext;
    currencyDefinitions? : CurrencyDefinition[];
    preferredExchangeCurrency? :string;
}

interface State {
    errorText: string;
    errorNoValue: boolean;
    priority?:PriorityType;
    isInternallyValid: boolean;
}

class ChooseWithdrawAmount extends React.PureComponent<Props,State>{

    constructor(props:Props) {
        super(props);
        this.state = {
            errorText:"",  errorNoValue: false, priority : undefined, isInternallyValid: true
        }
    }

    componentDidMount() {

        if(this.props.context?.cryptoContext?.fees?.priority) {
            let priority : PriorityType = Object.keys(this.props.context.cryptoContext?.fees?.priority)[0] as PriorityType;
            if(typeof(this.props.context?.cryptoContext.fees?.priority["medium"]) != "undefined") {
                priority = "medium";
            }
            this.setState({ priority : priority as PriorityType})
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        this.amountValid()
    }
    amountValid()  {
        let context = this.props.context;
        let isValid = true;
        this.setState({ isInternallyValid: isValid });
        try {
           let fee;
           if(context?.cryptoContext?.fees?.priority && this.state.priority && this.props.amount) {
               fee = context?.cryptoContext?.fees?.priority[this.state.priority];
               if(fee && new Big(fee).gte(new Big(this.props.amount))) {
                   this.setState({errorText:t("withdraw.fee-greater-than-amount")});
                   this.setState({isInternallyValid: false});
                   return false;
               }
           }
       } catch (e) {

       }

        if(this.props.balance) {
            let balance: AccountBalance  = this.props.balance;


            if(this.props.amount === '') {
                this.setState({errorNoValue: true});
                this.setState({isInternallyValid: false});
                return false;
            }

            if(balance && balance.balance) {
                if(balance.balance.amount !== undefined && this.props.amount) {
                    let balanceBig = balance.balance.amount;
                    let amountBig = Number(this.props.amount);
                    const isAmountNaN = isNaN(amountBig);

                    if (context?.minWithdraw) {
                      let minWithdraw = context.minWithdraw;
                      let maxWithdraw = context.maxWithdraw;
                      if (minWithdraw !== undefined && amountBig !== 0 && balanceBig !== 0) {
                        if (amountBig < minWithdraw) {
                          this.setState({ errorText: t("store.bundles.amountErrorMinWithdraw") + ": " + minWithdraw });
                          this.setState({isInternallyValid: false});
                          return false;
                        }
                      }
                      if (maxWithdraw !== undefined && amountBig !== 0 && balanceBig !== 0) {
                        if (amountBig > maxWithdraw) {
                          this.setState({ errorText: t("store.bundles.amountErrorMaxWithdraw") + ": " + maxWithdraw });
                          this.setState({isInternallyValid: false});
                          return false;
                        }
                      }
                    }
                    if (this.props.amount && this.props.amount.includes(".")) {
                      const currencyDefinition = this.getCurrency();
                      const fractionalDigits = currencyDefinition?.fractionalDigits;
                      const decimalPart = this.props.amount.split(".")[1];
                      if (decimalPart && fractionalDigits !== undefined && decimalPart.length > fractionalDigits) {
                          this.setState({ errorText: t("withdraw.amountErrorMaxDecimals") + ": " + fractionalDigits });
                          this.setState({isInternallyValid: false});
                          return false;
                      }
                  }

                    if (amountBig === 0) {
                      this.setState({ errorText: t("store.bundles.noZeroAmount") });
                      this.setState({isInternallyValid: false});
                      return false;
                    } else if (amountBig >= 0 && amountBig <= balanceBig) {
                      this.setState({ errorText: "" });
                      return true;
                    } else {
                      if (this.props.amount?.indexOf(",") != -1) {
                        this.setState({ errorText: t("withdraw.dotInsteadOfCommaError") });
                        this.setState({isInternallyValid: false});
                        return false;
                      }
                      if (isAmountNaN) {
                        this.setState({ errorText: t("withdraw.onlyNumbersError") });
                        this.setState({isInternallyValid: false});
                        return false;
                      }
                      this.setState({ errorText: t("store.bundles.amountError") });
                      this.setState({isInternallyValid: false});
                      return false;
                    }
                }
            }
        }
        this.setState({ isInternallyValid: isValid });
        return true;
    };

    setMaxWithdrawAmount() {
        const maxWithdraw:number = this.getMaxWithdrawAmount();
        this.props.update && this.props.update(maxWithdraw.toString())
    };

    getMaxWithdrawAmount() {
        const context:number = this.props.context && this.props.context.maxWithdraw || 0;
        const pBalance:number = this.props.balance?.balance?.amount || 0;
        const maxWithdraw:number = context >= pBalance ? pBalance : context;
        return maxWithdraw;
    }

    getCurrency() {
        let currency = this.props.currencies && this.props.currencies.find((currencyDef: CurrencyDefinition) => {
            if(this.props && this.props.currency && currencyDef.code == this.props.currency) {
                return true;
            }
        });
        return currency;
    }
    updateAmount(e:any) {
        return this.props.update && this.props.update(e.target.value)
    }
    showPossibleErrors() {
        this.props.showPossibleErrors && this.props.showPossibleErrors();
    }
    changePriority(val : PriorityType) {
        this.setState({ priority : val });
    }
    calculateFeeAndFinalAmount(fee : any, amount : string) {
        const def = { fee : "N/A", finalAmount: "N/A"};;
        if(!fee || !amount) {
            return def;
        }
        try {
            let feeBig = new Big(fee);
            let finalAmount = new Big(amount);
            return { fee : CurrencyFormatter.formatWithSymbol(this.getCurrency(), fee), finalAmount : CurrencyFormatter.formatWithSymbol(this.getCurrency(),finalAmount.minus(feeBig))}
        } catch (e) {
            return def;
        }

    }
    render() {

      let code = this.props.method && this.props.method.code;
      const {currency, amount} = this.props;
      let props = this.props;
      let priority = this.props.context?.cryptoContext?.fees?.priority;

        return (
          <div className={"cashier-container"}>
            <div className="withdraw-title">
              <Title animate={true} title={t("withdrawPage.amountPhaseTitle")} />
            </div>

            <div className={"row"}>
              <div className={"col-12 input-wrapper"}>
                <AmountInput
                  value={props.amount || ""}
                  onChange={(value) => props.update && props.update(value)}
                  currencySymbol={this.getCurrency()?.prefixSymbol || this.getCurrency()?.postfixSymbol}
                  presets={[this.getMaxWithdrawAmount()]}
                  max={this.getMaxWithdrawAmount()}
                  inputProps={{
                    onBlur: () => this.showPossibleErrors(),
                    inputMode: "numeric",
                  }}
                />
                {this.state.errorText && this.props.amount && this.props.amount.length > 0 && (
                  <span className="error-after-submit">{this.state.errorText}</span>
                )}
                {!this.state.errorText && this.state.errorNoValue && amount === "" && <div className="error-after-submit">{t("withdraw.withdrawEmptyError")}</div>}
                {this.state.errorText.length == 0 && props.amount && props.amountValid && props.currency && hasFiatExchangeAmount(props.currency, props.preferredExchangeCurrency, props.currencyDefinitions) && (
                    <span className={"exchange-amount"}>
                      {t("cashier.approximately")} {toFiatAmount(props.currency, parseFloat(props.amount), props.preferredExchangeCurrency, props.currencyDefinitions)}
                    </span>
                )}
              </div>
            </div>
            {priority && Object.keys(priority).length > 0 && (
              <>
                <div className={"row"}>
                  <div className={"col-12 input-wrapper"}>
                    <label>{t("withdraw.networkPriority")}</label>
                    <AppSelect
                      initialValue={this.state.priority || ""}
                      onChange={(priorityKey) => this.changePriority(priorityKey as PriorityType)}
                      renderActiveOption={(props) => <>{t("withdraw." + props?.value, { fee: CurrencyFormatter.formatWithSymbol(this.getCurrency(), priority?.[props?.value as PriorityType]) })}</>}
                      className="priority-select"
                    >
                      {Object.keys(priority).map((priorityKey) => (
                        <AppSelectOption
                          key={priorityKey}
                          value={priorityKey || ""}
                          label={t(`payments.method.${priorityKey}.name`, undefined, priorityKey) || ""}
                          method={priorityKey}
                        >
                          <>
                            {t("withdraw." + priorityKey, { fee: CurrencyFormatter.formatWithSymbol(this.getCurrency(), priority?.[priorityKey as PriorityType]) })}
                          </>
                        </AppSelectOption>
                      ))}
                    </AppSelect>
                    {this.state.priority && this.props.amount && !this.state.errorText && (
                      <div className={"row"}>
                        <div className={"col-12"}>
                          <span className={"feedback"}> {t("withdraw.fee-description", this.calculateFeeAndFinalAmount(priority[this.state.priority], this.props.amount))}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

              </>
            )}

            {code != "ACH" && (
              <BrandA className={"btn btn-cta full-width large"} onClick={() => this.props.confirmWithdraw?.(this.state.priority)} disabled={!this.props.amountValid || !this.state.isInternallyValid}>
                {t("withdrawPage.withdrawButtonText1")}
              </BrandA>
            )}
          </div>
        );
    }
}

const mapStateToProps = (app : AppState)=> {
    return {
        method : app.payments.withdraw.activeMethod,
        currency : app.payments.withdraw.activeCurrency,
        amount : app.payments.withdraw.amount,
        amountValid : app.payments.withdraw.amountValid,
        currencies: app.user.user != undefined ? app.user.user.currencies : undefined,
        showErrors : app.payments.withdraw.showPossibleErrors,
        context : app.payments.withdraw.withdrawContext,
        balance : getWithdrawableBalance(app),
        currencyDefinitions : getCurrencyDefinitions(app),
        preferredExchangeCurrency : getPreferredFiatExchange(app)

    }
};
const mapDispatchToProps = (dispatch: Dispatch)=> ({
    update : (amount : string, limit?:TransferLimit) => dispatch(updateWithdrawAmount(amount, limit)),
    confirmWithdraw : (priority?: string) => dispatch(confirmWithdraw(priority) as any),
    initWithdraw : () => dispatch(initWithdraw() as any),
    showPossibleErrors : () => dispatch(showPossibleWithdrawErrors() as any)

});

export default connect(mapStateToProps,mapDispatchToProps)(ChooseWithdrawAmount);
